import { c as _c } from "react/compiler-runtime";
import { faroCoreApiClient } from "@api/faro-core-api-client";
import { useAuthContext } from "@context-providers/auth/auth-context";
import { SecuredRoute } from "@router/secured-route";
import { HttpUtils } from "@stellar/utils";
import { useEffect, useState } from "react";
/**
 * Component to add to routes that require authentication, if the user is authenticated displays
 * the content and if not requests a login.
 * It can optionally add a required company role prop to make it also a secured route based
 * on the user company role.
 * The required company role defines the minimum company role that the user can have,
 * and if it doesn't match that criteria it redirects to a forbidden page.
 */
export function AuthenticatedRoute(t0) {
  const $ = _c(11);
  const {
    children,
    requiredRoleCompanyLevel,
    requiredFeatureCompanyLevel,
    requiredPermissionProjectLevel
  } = t0;
  const {
    showSessionExpiredDialog
  } = useAuthContext();
  const [isAuthenticated, setIsAuthenticated] = useState(true);
  let t1;
  let t2;
  if ($[0] !== showSessionExpiredDialog) {
    t1 = () => {
      const checkAuth = async function checkAuth() {
        ;
        try {
          await faroCoreApiClient.users.isLoggedIn();
          setIsAuthenticated(true);
        } catch (t3) {
          const error = t3;
          const errorStatus = HttpUtils.getErrorStatus(error);
          if (errorStatus && errorStatus === HttpUtils.HTTP_ERROR_CODE.Unauthorized) {
            showSessionExpiredDialog();
            setIsAuthenticated(false);
          }
        }
      };
      checkAuth();
    };
    t2 = [showSessionExpiredDialog];
    $[0] = showSessionExpiredDialog;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== children || $[4] !== isAuthenticated) {
    t3 = isAuthenticated ? <>{children}</> : null;
    $[3] = children;
    $[4] = isAuthenticated;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const returnJsx = t3;
  if (requiredRoleCompanyLevel || requiredFeatureCompanyLevel || requiredPermissionProjectLevel) {
    let t4;
    if ($[6] !== requiredFeatureCompanyLevel || $[7] !== requiredPermissionProjectLevel || $[8] !== requiredRoleCompanyLevel || $[9] !== returnJsx) {
      t4 = <SecuredRoute requiredRoleCompanyLevel={requiredRoleCompanyLevel} requiredFeatureCompanyLevel={requiredFeatureCompanyLevel} requiredPermissionProjectLevel={requiredPermissionProjectLevel}>{returnJsx}</SecuredRoute>;
      $[6] = requiredFeatureCompanyLevel;
      $[7] = requiredPermissionProjectLevel;
      $[8] = requiredRoleCompanyLevel;
      $[9] = returnJsx;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    return t4;
  }
  return returnJsx;
}